import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useId } from "../../hooks/use-id";
import { Accordion } from "../../components/shared/accordion";
import { PERSONAL_ACCOUNT_HELP_DATA } from "../data/personal-account-data";
import _ from "lodash";

/**
 * Componente que muestra las preguntas y respuestas correspondientes al perfil
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} ProfileHelp
 */
export const ProfileHelp = ({ interfaceTexts }) => {
	const titleId = useId("profile-title");
	const infoPlatform = [...PERSONAL_ACCOUNT_HELP_DATA];
	return (
		<section aria-labelledby={titleId}>
			<Link
				to={"/ayuda"}
				className="secondary-button py-2 px-3 focusable-red"
				aria-label={interfaceTexts?.accesibilidad?.volver || "Volver a la página de ayuda"}
			>
				<Icon icon="material-symbols:arrow-back-rounded" width="24" height="24" />
				{interfaceTexts?.botones?.volver || "volver"}
			</Link>

			<h2 id={titleId} className="my-4">
				{interfaceTexts?.perfil?.titulo || "Perfil"}
			</h2>
			<Accordion.Container>
				{infoPlatform?.map((item) => {
					const label =
						_.get(interfaceTexts, item?.textButton?.translationPath) ||
						item?.textButton?.default;
					return (
						<Accordion.Item key={item?.id}>
							<Accordion.ItemButton
								className={"acordeon px-3 py-2"}
								label={
									_.get(interfaceTexts, item?.textButton?.translationPath) ||
									item?.textButton?.default
								}
							/>
							<Accordion.Content
								className={"focusable-secondary opcionAcordeon relative"}
							>
								<div key={`video-${item?.id}`} className="w-100">
									<iframe
										src={
											_.get(interfaceTexts, item?.video?.translationPath) ||
											item?.video?.default
										}
										title={`Video: ${label}`}
										frameBorder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; fullscreen"
										allowFullScreen
										className="focusable-secondary videoInstruccion"
									></iframe>
								</div>
							</Accordion.Content>
						</Accordion.Item>
					);
				})}
			</Accordion.Container>
		</section>
	);
};
